import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import EnhancedSection from './components/EnhancedSection';
import { Field, Input } from '../components';
import { Actions, useConfigurationForm } from 'contexts/ConfigurationForm';
import usePermissions from 'hooks/usePermissions';
import { SectionId } from './constants';

const FieldWrapper = styled.div`
  > div {
    margin: 0;
  }
`;

const PreorderPeriodInputs = (props?: { onChange?: () => void }) => {
  const { t } = useTranslation(['main', 'common']);
  const {
    state: {
      editingState: { preorderPeriod },
      formErrors,
    },
    dispatch,
  } = useConfigurationForm();
  const canEdit = usePermissions('merchant', 'edit');
  const setPreorderPeriod = (value) => {
    dispatch(Actions.setPreorderPeriod(value));
    props?.onChange?.();
  };

  return (
    <EnhancedSection
      title={t('Preorder Period')}
      id={SectionId.PREORDER_PERIOD}
    >
      <EnhancedSection.Description>
        {t(
          'Let Google Merchant Center determine the shipping date for pre-order products.',
        )}
      </EnhancedSection.Description>
      <FieldWrapper>
        <Field title={t('Preorder Period')}>
          <Input
            block
            disabled={!canEdit}
            value={preorderPeriod}
            status={formErrors.preorderPeriod ? 'invalid' : 'valid'}
            preTextPosition="RIGHT"
            renderPreText={() => t('UNIT.days')}
            onChange={setPreorderPeriod}
            renderMessages={
              formErrors.preorderPeriod && [
                () =>
                  t(formErrors.preorderPeriod.key, {
                    ...formErrors.preorderPeriod.options,
                    fieldName: t('Preorder Period'),
                  }),
              ]
            }
          />
        </Field>
      </FieldWrapper>
    </EnhancedSection>
  );
};

export default PreorderPeriodInputs;
